import { Link } from "react-router-dom";
import { categories } from "../../../mocks/manga";

export default function Categories() {
  return (
    <section className="bg-background-100" aria-labelledby="category-heading">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6">
          <h2 id="category-heading" className="font-display text-2xl text-foreground-950 md:text-3xl">
            题材分类
          </h2>
          <p className="mt-1 text-sm text-foreground-500">按标签快速定位你喜欢的漫画类型</p>
        </div>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
          {categories.map((cat, idx) => (
            <Link
              key={cat.name}
              to={`/library?tag=${encodeURIComponent(cat.name)}`}
              className={`group flex flex-col items-center gap-3 rounded-2xl border border-background-200/70 p-5 text-center transition-transform hover:-translate-y-1 ${
                idx % 3 === 0 ? "bg-background-50" : idx % 3 === 1 ? "bg-accent-100/70" : "bg-secondary-100/70"
              }`}
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-2xl text-xl ${
                idx % 3 === 0 ? "bg-primary-100 text-primary-700" : idx % 3 === 1 ? "bg-accent-200 text-accent-800" : "bg-secondary-200 text-secondary-800"
              }`}>
                <i className={cat.icon} aria-hidden="true"></i>
              </span>
              <span className="font-display text-base text-foreground-950">{cat.name}</span>
              <span className="text-xs text-foreground-500">{cat.count} 部作品</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}